import { controls,grouped } from "../controls";
const departments = {
label: "Departments",
pageLabel: "Departments",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
bulk:{columns:["department_code","department_display"] },
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Department Limits",uid: "department_limits",fastpath:"limits"},
{label:"Bulk",uid:"bulk"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "department_code",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Description"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "department_display",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "filter",default:true, label: "Active", name: "department_active" }),
]
,form:[
...controls.displayText({ tab: "general", label: "Code",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "department_code",isRequired:true,maxlength:50}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Description",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "department_display",isRequired:true,maxlength:50}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "department_limits", label: "Start Dow",star:false}),
...controls.numberOnly({ tab: "department_limits",  placeHolder: "", name: "start_dow",maxlength:200}),
...controls.displayText({ tab: "department_limits", label: ""}),
...controls.displayText({ tab: "department_limits", label: "End Dow",star:false}),
...controls.numberOnly({ tab: "department_limits",  placeHolder: "", name: "end_dow",maxlength:200}),
...controls.displayText({ tab: "department_limits", label: ""}),
...controls.displayText({ tab: "department_limits", label: "Start Dom",star:false}),
...controls.numberOnly({ tab: "department_limits",  placeHolder: "", name: "start_dom",maxlength:200}),
...controls.displayText({ tab: "department_limits", label: ""}),
...controls.displayText({ tab: "department_limits", label: "End Dom",star:false}),
...controls.numberOnly({ tab: "department_limits",  placeHolder: "", name: "end_dom",maxlength:200}),
...controls.displayText({ tab: "department_limits", label: ""}),
...controls.displayText({ tab: "department_limits", label: "Start Month",star:false}),
...controls.numberOnly({ tab: "department_limits",  placeHolder: "", name: "start_month",maxlength:200}),
...controls.displayText({ tab: "department_limits", label: ""}),
...controls.displayText({ tab: "department_limits", label: "End Month",star:false}),
...controls.numberOnly({ tab: "department_limits",  placeHolder: "", name: "end_month",maxlength:200}),
...controls.displayText({ tab: "department_limits", label: ""}),
...controls.displayText({ tab: "department_limits", label: "From Time",star:false}),
...controls.text({ tab: "department_limits",  placeHolder: "", name: "from_time",maxlength:50}),
...controls.displayText({ tab: "department_limits", label: ""}),
...controls.displayText({ tab: "department_limits", label: "To Time",star:false}),
...controls.text({ tab: "department_limits",  placeHolder: "", name: "to_time",maxlength:50}),
...controls.displayText({ tab: "department_limits", label: ""}),
...controls.displayText({ tab: "department_limits", label: "Transaction Type",star:false}),
...controls.oc({ tab: "department_limits", c: "TransactionType", placeHolder: "Transaction Type Code", name: "transaction_type_code",fastpath: "transaction_types",hidden:false}),
...controls.showData({ tab: "department_limits", displaytype: "capital", data: "transaction_type_display"}),
...controls.displayText({ tab: "department_limits", label: "Amount"}),
...controls.floatOnly({ tab: "department_limits",  placeHolder: "", name: "amount",maxlength:16}),
...controls.displayText({ tab: "department_limits", label: ""}),
...controls.displayText({ tab: "department_limits", label: "Frequency",star:false}),
...controls.numberOnly({ tab: "department_limits",  placeHolder: "", name: "frequency",maxlength:200}),
...controls.displayText({ tab: "department_limits", label: ""}),
...controls.displayText({ tab: "department_limits", label: "Form",star:false}),
...controls.oc({ tab: "department_limits", c: "Form", placeHolder: "Form Code", name: "form_code",fastpath: "forms",hidden:false}),
...controls.showData({ tab: "department_limits", displaytype: "capital", data: "form_display"}),
...controls.checkBox({ tab: "department_limits", label: "Can Create New",default:false, name: "can_create_new" }),
...controls.checkBox({ tab: "department_limits", label: "Can Update",default:false, name: "can_update" }),
...controls.checkBox({ tab: "department_limits", label: "Disable Gui Update",default:false, name: "disable_gui_update" }),
...controls.checkBox({ tab: "department_limits", label: "Can Delete",default:false, name: "can_delete" }),
...controls.checkBox({ tab: "department_limits", label: "Can Auth",default:false, name: "can_auth" }),
...controls.checkBox({ tab: "department_limits", label: "Can Print",default:false, name: "can_print" }),
...controls.checkBox({ tab: "department_limits", label: "Can Export",default:false, name: "can_export" }),
...controls.checkBox({ tab: "department_limits", label: "Can Share",default:false, name: "can_share" }),
...controls.checkBox({ tab: "department_limits", label: "Is Lifetime Limit",default:false, name: "is_lifetime_limit" }),

...controls.displayText({ tab:"department_limits" ,width:"col-sm-12", label: "" }),
...controls.displayText({ tab:"department_limits" ,width:"col-sm-4", label: "" }),
...controls.button({
tab:"department_limits",
 label: "ADD",
 style: { padding: 0 },
Bcolor: "success",
 onclick: {
  action: "appendToHTMLTable",
  tableNameField: "department_limits",
  requiredField: ["start_dow","end_dow","start_dom","end_dom","start_month","end_month","from_time","to_time","transaction_type_code","transaction_type_display","transaction_type_uid","amount","frequency","form_code","form_display","form_uid","can_create_new","can_update","disable_gui_update","can_delete","can_auth","can_print","can_export","can_share","is_lifetime_limit",],
required:[],
}, width: "col-sm-2"
}),
...controls.button({
tab:"department_limits",
 label: "CLEAR",
 style: { padding: 0 },
Bcolor: "warning",
 onclick: {
  action: "clearForm",
  tableNameField: "department_limits",
  requiredField: ["start_dow","end_dow","start_dom","end_dom","start_month","end_month","from_time","to_time","transaction_type_code","transaction_type_display","transaction_type_uid","amount","frequency","form_code","form_display","form_uid","can_create_new","can_update","disable_gui_update","can_delete","can_auth","can_print","can_export","can_share","is_lifetime_limit",]
}, width: "col-sm-2"
}),
{
  tab:"department_limits",
inputType: "table",
  tableTitle: "",
  deletable: true,
  editable: true,
  tableHeaders: [
    { label: "Sr", type: "autoinc" },
    { label: "Start Dow", field: "start_dow"},
    { label: "End Dow", field: "end_dow"},
    { label: "Start Dom", field: "start_dom"},
    { label: "End Dom", field: "end_dom"},
    { label: "Start Month", field: "start_month"},
    { label: "End Month", field: "end_month"},
    { label: "From Time", field: "from_time"},
    { label: "To Time", field: "to_time"},
    { label: "Transaction Type Code", field: "transaction_type_code"},
    { label: "Transaction Type ", field: "transaction_type_display"},
    { label: "Amount", field: "amount"},
    { label: "Frequency", field: "frequency"},
    { label: "Form Code", field: "form_code"},
    { label: "Form ", field: "form_display"},
    { label: "Can Create New", field: "can_create_new", displaytype: "tick"},
    { label: "Can Update", field: "can_update", displaytype: "tick"},
    { label: "Disable Gui Update", field: "disable_gui_update", displaytype: "tick"},
    { label: "Can Delete", field: "can_delete", displaytype: "tick"},
    { label: "Can Auth", field: "can_auth", displaytype: "tick"},
    { label: "Can Print", field: "can_print", displaytype: "tick"},
    { label: "Can Export", field: "can_export", displaytype: "tick"},
    { label: "Can Share", field: "can_share", displaytype: "tick"},
    { label: "Is Lifetime Limit", field: "is_lifetime_limit", displaytype: "tick"},
  ],
  widths: {
    parent: "col-sm-12",
    children: "col-sm-12"
  },
  name: "department_limits"
},
]
,history:{
perPage: 10,
reportHeader: "Departments",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Department Code",accessor: "department_code",},
{Header: "Department",accessor: "department_display",},
{Header: "Department Active",accessor: "department_active",type:'tick'},
]}};
export default departments;